export default __webpack_public_path__ + "static/media/2603202401.dc1cced85eb8cf1f2783cc400cee10de.png";